import { render, staticRenderFns } from "./SidebarDesktopContent.vue?vue&type=template&id=96e5c294&scoped=true&"
import script from "./SidebarDesktopContent.vue?vue&type=script&lang=js&"
export * from "./SidebarDesktopContent.vue?vue&type=script&lang=js&"
import style0 from "./SidebarDesktopContent.vue?vue&type=style&index=0&id=96e5c294&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e5c294",
  null
  
)

export default component.exports